import { render, staticRenderFns } from "./ScheduledVsManualCard.vue?vue&type=template&id=9d7cb624"
import script from "./ScheduledVsManualCard.vue?vue&type=script&lang=js"
export * from "./ScheduledVsManualCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports